module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Names Actions</h1>\n<div class="grid-container">\n    <div class="grid-40">\n        <strong>Create message</strong><br/>\n        Create a Joinos message\n    </div>\n    <div class="grid-10">\n        <a class="button button-secondary button-create-message">Create</a>\n    </div>\n</div>\n\n<hr/>\n\n<div class="grid-container">\n    <div class="grid-40">\n        <strong>Create group</strong><br/>\n        Create a user-defined group\n    </div>\n    <div class="grid-10">\n        <a class="button button-secondary button-create-group">Create</a>\n    </div>\n</div>\n<br/>\n<a class="button button-secondary button-close pull-right">Close</a>\n<br/>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./names/templates/dropdown.html
// module id = 356
// module chunks = 0